import React from "react";
import { StyledContents } from "../utils/StyleUtils";
const EscapeKeyBoundary = ({ disabled = false, children }) => {
    const stopEscapePropagation = (e) => {
        if (!disabled && e.key === "Escape") {
            e.stopPropagation();
        }
    };
    return (React.createElement(StyledContents, { as: "span", onKeyDown: stopEscapePropagation, onKeyUp: stopEscapePropagation }, children));
};
export default EscapeKeyBoundary;
//# sourceMappingURL=EscapeKeyBoundary.js.map